import { ImageLibraryServiceModule } from './imageLibrary.service';
import { ImageLibraryDropzoneModule } from './imageLibraryDropzone.directive';
import { ImageLibraryLaunchModule } from './launchImageLibrary.directive';
import { ImageLibraryItemModule } from './imageLibraryItem.component';

export const ImageLibraryModule = angular
    .module('vln.imageLibrary', [
        'angular-clipboard',

        ImageLibraryServiceModule,
        ImageLibraryDropzoneModule,
        ImageLibraryLaunchModule,
        ImageLibraryItemModule
    ]).name;


// WEBPACK FOOTER //
// ./src/app/components/imageLibrary/imageLibrary.module.js